import {Component, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  template: ''
})
export class FieldsInterventionsNavigationActivatedComponent implements OnChanges {
  protected isActivated: boolean;

  protected onActivated() {
  }

  protected onDeactivated() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('hidden')) {
      if (!changes.hidden.currentValue) {
        this.isActivated = true;
        this.onActivated();
      } else {
        this.isActivated = false;
        this.onDeactivated();
      }
    }
  }
}
